import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import employeeService from '../../../../services/Employee.service'

import StencilLinkStyling from '../StencilLinkStyling'
import {GenericDetailTitle} from "./GenericDetailTitle"

import { Text } from '@amzn/stencil-react-components/text'
import { Col, Hr } from '@amzn/stencil-react-components/layout'
import { Button, ButtonIconPosition, ButtonVariant, ButtonSize } from "@amzn/stencil-react-components/button"
import { IconExternalLink } from '@amzn/stencil-react-components/icons'
import { Flyout, FlyoutContent } from "@amzn/stencil-react-components/flyout"

class VestElectionsDialog extends Component {

  onChangeTaxPaymentBrokerButtonClick = () => {
    var brokerUrl = employeeService.getEmployeeBrokerUrl(this.props.employee)

    if(this.props.employee.broker && brokerUrl && this.props.employee.broker !== '') {
      var win = window.open(brokerUrl, '_blank');
      win.focus();
    }
  }

  isOption = (awards, awardId) => {
    if (awards && awardId) {
      var award = employeeService.loadAward(awards, awardId);
      return award ? employeeService.isOption(award) : false;
    }

    return false;
  }

  generateTaxMethodInformation = (employee, awardIdSelected, calendarYear, vest, t) => {

    let methods = '';

    if (vest) {
      methods = t(`TaxTreatment.${vest.tax_election.code}`);
    } else {
      methods = employeeService.getPaymentMethods(employee.awards, awardIdSelected, calendarYear)
        .map(taxElectionCode => t(`TaxTreatment.${taxElectionCode}`))
        .join(', ');
    }

    let taxElectionsEmail = t('VestElectionsDialog.TaxElectionEmailNoAPS');
    if (employeeService.isZooxEmployee(employee)){
      taxElectionsEmail = t('VestElectionsDialog.TaxElectionEmailZoox');
    }
    if (employeeService.isAPSEmployee(employee)) {
      return (
        <>
          {this.generateCurrentMethodTextBox(methods, t)}
          <Button size={ButtonSize.Small} style={{width: "fit-content"}} onClick={this.onChangeTaxPaymentBrokerButtonClick} icon={<IconExternalLink aria-hidden="true"/>} iconPosition={ButtonIconPosition.Trailing}>{t('VestElectionsDialog.ChangeTax')}</Button>
          {employeeService.showTaxElectionMessage(employee) &&
            <StencilLinkStyling>
              <Text dangerouslySetInnerHTML={{ __html: t('VestElectionsDialog.TaxElectionMessage') }}></Text>
            </StencilLinkStyling>
          }
        </>
      );
    } else {
      return (
        <>
          {this.generateCurrentMethodTextBox(methods, t)}
          <Button size={ButtonSize.Small} style={{width: "fit-content"}} onClick={this.onChangeTaxPaymentBrokerButtonClick} icon={<IconExternalLink aria-hidden="true"/>} iconPosition={ButtonIconPosition.Trailing}>{t('VestElectionsDialog.ChangeTax')}</Button>
          <StencilLinkStyling>
            <Text dangerouslySetInnerHTML={{ __html: t('VestElectionsDialog.TaxElectionMessageNoAPS') }}></Text>
            <Text dangerouslySetInnerHTML={{ __html: taxElectionsEmail }}></Text>
          </StencilLinkStyling>
        </>
      );
    }
  }

  generateCurrentMethodTextBox = (method, t) => {
    return (
      <Col backgroundColor='#F1F4F7' padding="S300" style={{border:"solid 1px", borderColor: "#D1D5DA"}} >
        <Text>{t('VestElectionsDialog.CurrentMethod')}</Text>
        <Text fontWeight="bold">{method}</Text>
      </Col>
    );
  }

  render() {
    const { t, employee, awardIdSelected, calendarYear, vest } = this.props;
  
    if(!this.props.visible) {
      return null;
    }

    var fractionalEnable = this.props.fractional_mode && !this.isOption(employee.awards, awardIdSelected) && employeeService.hasFractionalEligibleVest(employee);

    let excessMethod = employeeService.getVestFractionalElectionText(t, employee, vest);

    return (
      <Flyout dataTestId="VestElectionsDialog" isOpen={this.props.visible} close={this.props.onDialogClose} isScrollable={false}>
        <FlyoutContent
          titleText={t('VestElectionsDialog.Title')}
          onCloseButtonClick={this.props.onDialogClose}
        >
          <Col gridGap="S300">
            <GenericDetailTitle
              title={t('VestElectionsDialog.TaxPaymentMethod')}
            />
            <Text>{t('VestElectionsDialog.AvailableMethods')}</Text>
            <Col style={{paddingLeft: 25}}>
              <ul style={{listStyleType:"square"}}>
                  <li><Text>{t(`TaxTreatment.0`)}&nbsp;{t('VestElectionsDialog.DefaultLabel')}</Text></li>
                  <li><Text>{t(`TaxTreatment.1`)}</Text></li>
                  <li><Text>{t(`TaxTreatment.2`)}</Text></li>
              </ul>
            </Col>
            {!employeeService.isBrokerChoiceNone(employee) && 
              this.generateTaxMethodInformation(employee, awardIdSelected, calendarYear, vest, t)
            }
            
            <StencilLinkStyling>
              <Text dangerouslySetInnerHTML={{ __html: t('VestElectionsDialog.SeeDetail') }}></Text>
            </StencilLinkStyling>
          </Col>

          {fractionalEnable &&
            <Col gridGap="S300" margin={{top: "S500"}}>
              <Hr/>
              <GenericDetailTitle
                title={t('VestElectionsDialog.FractionalShareElection')}
              />
              <Text>{t('VestElectionsDialog.IfElected')}</Text>
              <Col style={{paddingLeft: 25}}>
                <ul style={{listStyleType:"square"}}>
                  <li><Text>{t(`VestElectionsDialog.SellForTaxesCash`)}</Text></li>
                  <li><Text>{t(`VestElectionsDialog.SellForTaxesFractional`)}</Text></li>
                </ul>
              </Col>
              {this.generateCurrentMethodTextBox(excessMethod, t)}
              <Button size={ButtonSize.Small} style={{width: "fit-content"}} variant={ButtonVariant.Secondary} onClick={this.props.onChangeDeliveryMethodButtonClick}>{t('VestElectionsDialog.ChangeDeliveryMethod')}</Button>
            </Col>
          }
        </FlyoutContent>
      </Flyout>
    );
  }
}

const mapState = state => ({
  employee: state.employee,
  fractional_mode: state.static_content.fractional_mode
})

export default connect(mapState)(withTranslation('translationsV2')(VestElectionsDialog))

